import { render, staticRenderFns } from "./modal-reminder-note.vue?vue&type=template&id=7c46ca21&scoped=true&lang=pug"
import script from "./modal-reminder-note.js?vue&type=script&lang=js&external"
export * from "./modal-reminder-note.js?vue&type=script&lang=js&external"
import style0 from "./modal-reminder-note.vue?vue&type=style&index=0&id=7c46ca21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c46ca21",
  null
  
)

export default component.exports